













































































































import BaseItemsPage from "../BaseItemsPage";
import { EmailDetailItem } from "@/store/email/statistic/types";
import { Component } from "vue-property-decorator";
import EmailDetailFilter from "@/components/Email/Statistic/EmailDetailFilter.vue";
import { ScrollButton } from "wings-ui-components";
import { Getter } from "vuex-class";
import { dateFilter } from "@/utils/date-util";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: {EmailDetailFilter, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus},
})
export default class EmailDetail extends BaseItemsPage<EmailDetailItem> {

  @Getter("emailStatisticDetail") responseItems!: EmailDetailItem[];
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'create_date', 'originator', 'recipient', 'partner',
      'service_provider', 'subject', 'status', 'detail',
    ];
  }

  getData() {
    return this.responseItems;
  }
}
